import { Map } from "immutable";
import React from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import comm from "../core/comm/actions";
import { applyURLVars } from "../core/comm/api";
import { HOST_URL } from "../core/config";

function useGoBack() {
  const history = useHistory();

  return React.useCallback(() => {
    history.goBack();
  }, []);
}

function useGo(to) {
  const history = useHistory();

  return React.useCallback((urlParams) => {
    const url = applyURLVars(to, Map(urlParams));
    history.push(url);
  }, []);
}

function useReplace(to) {
  const history = useHistory();

  return React.useCallback((urlParams) => {
    const url = applyURLVars(to, Map(urlParams));
    history.replace(url);
  }, []);
}

/**
 * @param {String} to uri de uma tela do coruja (opcional).
 * @returns {Function} equivalente ao usuário digitar outra URL na barra
 *                     do navegador e apertar enter.
 */
function useRedirect(to, blank = null) {
  const dispatch = useDispatch();

  return React.useCallback(() => {
    if (blank) {
      window.open(to, "_blank");
      return;
    }
    dispatch(comm.refresh(to));
  }, [to, blank]);
}
/**
 * @param {String} to uri de uma tela do coruja (opcional).
 * @param {String} token token (opcional).
 * @returns {Function} equivalente ao usuário apertar F5.
 */
function useRefresh(to, token) {
  const dispatch = useDispatch();

  return React.useCallback(() => {
    let url = HOST_URL;
    if (to) {
      url = `${url}${to}`;
    }
    if (token) {
      url = `${url}?token=${token}`;
    }

    dispatch(comm.refresh(url));
  }, [to, token]);
}

const Hooks = { useGo, useRefresh, useRedirect, useGoBack, useReplace };

export { applyURLVars };
export default Hooks;
